import React, { Component } from 'react'
import { Icon } from 'loyal-react'
import PropTypes from 'prop-types'

class Search extends Component {
  constructor (props) {
    super(props)

    this.state = {
      term: '',
      timer: 0,
      autoCompleteFilled: true,
      hideSearchField: true,
      verifyTrigger: true,
      clickedSearch: false,
      msgMostSearched: ''
    }
    this.setTerm = this.setTerm.bind(this)
  }

  handleKeyUp (e) {
    if (e.key === 'Enter') {
      this.emptyTerm()
      this.hideSearchField()
      this.props.redirect('/search?term=' + e.target.value)
      this.setState({ verifyTrigger: false })
    } else if (e.key === 'Escape') {
      this.hideSearchField()
    }
  }

  searchTrigger (e) {
    if (e.key !== 'Tab') {
      this.emptyTerm()
      this.props.redirect('/search?term=' + this.state.term)
      this.setState({ verifyTrigger: false })
    }
  }

  emptyTerm () {
    this.setState({
      autoCompleteFilled: true,
      term: ''
    })
  }

  setTerm (value) {
    this.setState({ term: value })
  }

  setAutoComplete (isFilled) {
    this.setState({ autoCompleteFilled: isFilled })
  }

  showSearchField () {
    this.setState({
      hideSearchField: false
    })

    setTimeout(() => {
      const logo = document.querySelector('.logo-header-link')

      logo && (
        logo.setAttribute('aria-hidden', 'true')
      )
      document.getElementById('box-search-field-mobile-close') &&
      document.getElementById('box-search-field-mobile-close').focus()
    }, 100)
  }

  hideSearchField () {
    this.setState({
      hideSearchField: true,
      clickedSearch: false,
      autoCompleteFilled: true
    })

    setTimeout(() => {
      const logo = document.querySelector('.logo-header-link')

      logo && (
        logo.setAttribute('aria-hidden', 'false')
      )
      document.getElementById('box-search-field-mobile-open') && document.getElementById('box-search-field-mobile-open').focus()
    }, 500)
  }

  render () {
    const searchLabel = 'O que você está buscando hoje?'

    return (
      <div
        className={`search zindex${!this.state.hideSearchField ? '-high' : ''} d-sm-block d-auto col-xs-12 col-sm px-xs-1 px-sm-4 ml-auto`}
        role='search'
      >
        <div className='row align-items-center h-100'>
          <div className='col-12 form-field search-field'>
            <p className='hide-absolute color-ui-white' role='status'
              aria-live='assertive'
              aria-atomic='true'>
              {this.state.term !== '' && (this.props.isLoading ? 'Auto-completar: Carregando resultados' : 'Resultado completo')}
            </p>
            <p className='hide-absolute color-ui-white' role='status'
              aria-live='assertive'
              aria-atomic='true'>
              {!this.state.autoCompleteFilled ? 'Exibindo os termos mais buscados' : this.state.msgMostSearched}
            </p>
            <div className='box-search-field-desktop d-none d-sm-block'>
              <label htmlFor='buscar-desktop' className='hide-absolute'>{searchLabel}</label>
              <input
                className='no-label no-border radius color-ui-2'
                id='buscar-desktop'
                type='text'
                placeholder={searchLabel}
                name='buscar'
                onChange={e => this.setTerm(e.target.value)}
                value={this.state.term}
                onKeyUp={(e) => this.handleKeyUp(e)}
                onBlur={() => this.props.emptySearch()}
                autoComplete='off'
              />
              <button
                tabIndex={0}
                className={`h-100 btn-sm btn btn-flat btn-icon btn-icon-only`}
                role='button'
                aria-label={this.props.isLoading ? `Auto-completar: Carregando resultados...` : `Buscar por produtos`}
                id='btn-search-loupe'
                onClick={e => !this.props.isLoading && this.searchTrigger(e)}
                onBlur={() => this.props.emptySearch()}
                readOnly={this.props.isLoading}
              >
                <Icon
                  iconName={!this.props.isLoading ? 'icon_search' : 'icon_loading'}
                  className={!this.props.isLoading ? 'color-brand-2' : 'color-ui-1'}
                />
              </button>
            </div>
            <div id='box-search-field-mobile' className='box-search-field-mobile d-block d-sm-none'>
              <button
                id='box-search-field-mobile-close'
                className={`h-100 btn-sm btn btn-flat btn-icon btn-icon-only restore-search ${
                  this.state.hideSearchField ? 'd-none' : ''
                }`}
                role='button'
                onClick={() => this.hideSearchField()}
                aria-label='Fechar campo de busca'
                aria-haspopup='true'
                aria-expanded={!this.state.hideSearchField}
              >
                <Icon
                  iconName={'icon_left_app'}
                  className={'color-brand-5'}
                />
              </button>
              <input
                className={`no-label no-border radius color-ui-2 ${
                  this.state.hideSearchField ? 'd-none' : ''
                }`}
                id='buscar-mobile'
                type='text'
                tabIndex={0}
                placeholder={searchLabel}
                name='buscar'
                onChange={e => this.setTerm(e.target.value)}
                value={this.state.term}
                onKeyUp={(e) => this.handleKeyUp(e)}
                autoComplete='off'
                disabled={this.state.hideSearchField}
              />
              <button
                id='box-search-field-mobile-open'
                className={`h-100 btn-sm btn btn-flat btn-icon btn-icon-only ${
                  this.state.hideSearchField ? '' : 'd-none'
                }`}
                aria-label='Exibir campo de busca'
                onClick={() => this.showSearchField()}
                aria-haspopup='true'
                aria-expanded={!this.state.hideSearchField}
              >
                <Icon
                  iconName={!this.props.isLoading ? 'icon_search' : 'icon_loading'}
                  className={!this.props.isLoading ? 'color-ui-1' : 'color-brand-2'}
                />
              </button>
              <button
                tabIndex={0}
                className={`h-100 btn-sm btn btn-flat btn-icon btn-icon-only ${
                  this.state.hideSearchField ? 'd-none' : ''
                }`}
                role='button'
                aria-label={this.props.isLoading ? `Auto-completar: Carregando resultados...` : `Buscar por produtos`}
                id='btn-search-loupe-mobile'
                onClick={e => !this.props.isLoading && this.searchTrigger(e)}
                onBlur={() => this.props.emptySearch()}
                readOnly={this.props.isLoading}
              >
                <Icon
                  iconName={!this.props.isLoading ? 'icon_search' : 'icon_loading'}
                  className={!this.props.isLoading ? 'color-brand-2' : 'color-ui-1'}
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Search.propTypes = {
  emptySearch: PropTypes.func,
  redirect: PropTypes.func,
  isLoading: PropTypes.bool
}

export default Search



// WEBPACK FOOTER //
// ./src/App/Header/Search/Search.js